module.exports = __webpack_public_path__ + "static/media/logo-white.f1c7f4f0.png";